import { alpha } from '@mui/material';

export default {
  root:
    ({ width, image, height, m = 2, my = 3 }) =>
    ({ palette }) => ({
      m,
      my,
      width: width || '100%',
      height: height || 315,
      overflow: 'hidden',
      borderRadius: '10px',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundImage: `url(${image})`,
      filter: `drop-shadow(0px 0px 10px ${palette.secondary.dark})`,
      '& > div': {
        opacity: 0,
        transition: '0.3s',
      },
      '&:hover > div': {
        opacity: 1,
      },
    }),
  overlay:
    ({ isMobile }) =>
    ({ palette }) => ({
      cursor: 'pointer',
      p: 2,
      pb: isMobile ? 2 : 5,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'flex-end',
      background: `linear-gradient(180deg, ${alpha(palette.background.default, 0.3)} 0%, ${alpha(
        palette.background.default,
        0.7
      )} 88.46%)`,
    }),
};
